import React from "react";
import { motion } from "framer-motion";
import { BookOpen, ArrowUpRight } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const MENU_URL = "https://pnssm.pro/2ef0e7n";

export const MenuIntermezzo = () => {
  const { t } = useT();
  const x = t.menuIntermezzo;
  return (
    <section
      className="relative py-16 md:py-24 px-6 md:px-10 text-center overflow-hidden bg-noir"
      data-testid="menu-intermezzo-section"
    >
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />
      <div className="relative max-w-[720px] mx-auto flex flex-col items-center gap-7">
        <motion.h3
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1] }}
          className="font-display font-light text-[22px] sm:text-[26px] md:text-[32px] leading-[1.25] tracking-[-0.005em] text-[var(--pn-milk)]"
        >
          {x.title_a}{" "}
          <em className="italic text-[var(--pn-amber)]">{x.title_b}</em>
        </motion.h3>
        <motion.a
          href={MENU_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.9 }}
          className="cta-outline-amber !text-[15px] md:!text-[16px] !py-[17px] !px-[34px]"
          data-testid="menu-intermezzo-link"
        >
          <BookOpen size={18} strokeWidth={1.5} />
          <span className="tracking-[0.16em]">{x.btn}</span>
          <ArrowUpRight size={16} strokeWidth={1.5} />
        </motion.a>
      </div>
    </section>
  );
};
